<div class="pb-2">
  <rask-datepicker
    class="col-lg-3 col-sm-4 p-0 me-1"
    [(ngModel)]="startdatum"
    (change)="onCalendarChange($event)"
    [disabled]="arbetsorder.isExternArbetsorder"
    label="produktionsdatum">
  </rask-datepicker>

  <rask-datepicker
    class="col-lg-3 col-sm-4 p-0 me-1"
    [(ngModel)]="slutdatum"
    (change)="onCalendarChange($event)"
    [disabled]="arbetsorder.isExternArbetsorder">
  </rask-datepicker>

  @if (!isTerminalImportOrExternArbetsorder()) {
    <rask-button class="p-0 ms-1" color="secondary" (click)="getSuggestion()">
      <small>Hämta föreslaget produktionsdatum</small>
    </rask-button>
  }
</div>
